import type { Guide } from '../types';

/** S-24.10-12 — parametry i stawki kosztu: właściciel, data obowiązywania, historia (scenariusz e2e 29). */
export const guide: Guide = {
  flagKey: 'parameterOwnership',
  title: 'Parametry i stawki kosztu: właściciel, data obowiązywania, historia',
  whatItDoes:
    'Każdy parametr rekomendacji ma właściciela biznesowego i datę, od której obowiązuje jego wartość. Zmianę można zaplanować: nowa wartość z datą „obowiązuje od” przed tą datą niczego nie zmienia, a do tego czasu można ją odwołać z powodem. Historia mówi: było, jest, od kiedy, kto i dlaczego. Stawki kosztu spółki działają tak samo — powód jest obowiązkowy, jest data „obowiązuje od”, właściciel stawek i własna historia. Koszt liczy stawka obowiązująca teraz; puste pole zostaje puste.',
  audience: ['administrator', 'Team Leader (planista główny)'],
  presentationItems: ['S-24.10-12'],
  steps: [
    {
      route: '/suggestion-parameters',
      target: 'parameter-ownership-note',
      title: 'Właściciel i obowiązywanie przy każdym parametrze',
      description:
        'Nowa kolumna „Właściciel i obowiązywanie”: kto odpowiada za wartość (pusty — właściciel nieustalony), od kiedy obowiązuje wartość i zmiana zaplanowana z datą.',
      action: 'Otwórz „Parametry rekomendacji” i przeczytaj opis nad tabelą.',
      recorder: { account: 'admin' },
    },
    {
      route: '/suggestion-parameters',
      target: 'parameter-owner-edit-planningHorizonDays',
      title: 'Właściciel parametru',
      description:
        'Przycisk „Właściciel” zmienia właściciela biznesowego parametru — z powodem, który trafia do historii.',
      action: 'Kliknij „Właściciel” przy parametrze, wpisz właściciela i powód.',
      recorder: { account: 'admin' },
    },
    {
      route: '/suggestion-parameters',
      target: 'parameter-valid-from',
      title: 'Zmiana zaplanowana',
      description:
        'W oknie „Zmień” pole „Obowiązuje od”: puste — zmiana działa od razu; data w przyszłości — do tego czasu obowiązuje obecna wartość, a przy parametrze widać zaplanowaną zmianę z przyciskiem „Odwołaj”.',
      action: 'Kliknij „Zmień” przy parametrze, wpisz wartość, datę „Obowiązuje od” i powód.',
      recorder: {
        account: 'admin',
        actions: [{ kind: 'clickButton', name: 'Zmień', rowText: 'Horyzont podpowiedzi' }],
      },
    },
    {
      route: '/companies',
      target: 'cost-rates-history-*',
      title: 'Stawki kosztu spółki z historią',
      description:
        'Przy kosztach dolotu spółki przycisk „Historia”: było, jest, od kiedy, kto i powód, ze zmianami zaplanowanymi i odwołanymi. W oknie „Ustaw” — właściciel stawek, „Obowiązuje od” i obowiązkowy powód.',
      action: 'Otwórz „Spółki” i kliknij „Historia” przy kosztach dolotu.',
      recorder: { account: 'admin' },
    },
  ],
};
